import { PlanType } from '../../enums/user';

export class AccountModel {
    id: number;
    accountName: string;
    planType: PlanType;
    accountCreationDateTime: string;
    accountStartDate: string;
    accountExpirationDate: string;
    isDeleted: boolean;
    isActive: boolean;
    createdDateTime: string;
    updatedDateTime: string;

    constructor() {
        this.id = 0;
        this.accountName = '';
        this.planType = PlanType.Trial;
        this.accountCreationDateTime = '';
        this.accountStartDate = '';
        this.accountExpirationDate = '';
        this.isDeleted = false;
        this.isActive = true;
        this.createdDateTime = '';
        this.updatedDateTime = '';
    }
}
